import { useEffect } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Card, CardContent, Container, Typography } from '@mui/material'
import { SecurityOutlined } from '@mui/icons-material'

export default function Login() {
  const { oktaAuth, authState } = useOktaAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (authState?.isAuthenticated) {
      navigate('/')
    }
  }, [authState, navigate])

  const handleLogin = async () => {
    await oktaAuth.signInWithRedirect()
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <Card sx={{ width: '100%', textAlign: 'center' }}>
          <CardContent sx={{ p: 4 }}>
            <SecurityOutlined sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
            <Typography variant="h4" component="h1" gutterBottom>
              HR Fraud Detection Agent
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              Automated candidate fraud detection for JazzHR
            </Typography>
            <Button
              variant="contained"
              size="large"
              onClick={handleLogin}
              sx={{ mt: 2 }}
              fullWidth
            >
              Sign in with Okta
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Container>
  )
}
